import type {
  CreateAttestationRequestBodySource,
  ListPendingAttestationsParams,
} from '@moment/horizon-data-access/platform'

/**
 * The surface the horizon attestation registry gates the AI copilot under.
 * The params the gate reads and the source it records are paired here so the
 * two halves cannot drift apart.
 */
export const COPILOT_SURFACE = {
  params: {
    surface: 'proposal_builder',
  } satisfies ListPendingAttestationsParams,
  // Literals, not the generated enum objects: this module is reachable from
  // api/base-api-slice, which suites load while mocking the generated module
  // with factories that export neither.
  source: 'proposal_builder_v2' satisfies CreateAttestationRequestBodySource,
} as const
